import {useDraggable, useDroppable} from '@github-ui/drag-and-drop'
import {memo, useRef} from 'react'

import type {BoardDndCardEventData} from '../board-dnd-context'
import useIsVisible from '../hooks/use-is-visible'
import {Card} from './index'
import type {CardProps} from './types'

export const DraggableCard = memo(function DraggableCardComponent({
  item,
  verticalGroup,
  columnIndex,
  isDragDisabled,
  horizontalGroupIndex,
  ...restProps
}: Omit<CardProps, 'isVisible' | 'size'>) {
  const ref = useRef<HTMLDivElement>(null)
  const {isVisible, size} = useIsVisible({ref})

  const {
    attributes,
    listeners,
    setNodeRef: setDragRef,
  } = useDraggable({
    id: item.id,
    data: {
      type: 'card',
      item,
      ref,
      verticalGroup,
      columnIndex,
      horizontalGroupIndex,
    } satisfies BoardDndCardEventData,
    disabled: isDragDisabled || !isVisible,
  })
  const {setNodeRef: setDropRef} = useDroppable({
    id: item.id,
    data: {
      type: 'card',
      item,
      ref,
      verticalGroup,
      columnIndex,
      horizontalGroupIndex,
    } satisfies BoardDndCardEventData,
    disabled: !isVisible,
  })

  setDropRef(ref.current)

  setDragRef(ref.current)

  return (
    <Card
      size={size}
      ref={ref}
      item={item}
      verticalGroup={verticalGroup}
      columnIndex={columnIndex}
      isDragDisabled={isDragDisabled}
      horizontalGroupIndex={horizontalGroupIndex}
      {...restProps}
      isVisible={isVisible}
      {...attributes}
      {...listeners}
    />
  )
})
